import BaseModel from '../base/BaseModel.model';
export default class AnnoucementPublish extends BaseModel {

   public id: number =  0;
   public title: string ="";
   public fileName?:string = "";
   public areaName?:string = "";
   public researchLineName?:string = "";

   public dateOpen: Date | any;
   public dateEnd: Date | any;

    init(){
        this.id = 0;
        this.title  ="";
        this.fileName = "";
        this.areaName = "";
        this.researchLineName = "";

    }
}